import { render, staticRenderFns } from "./IdentificationClients.vue?vue&type=template&id=9ab494a0"
import script from "./IdentificationClients.vue?vue&type=script&lang=js"
export * from "./IdentificationClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports